/**
 * ehr#274 (Chase 10-10): the progress note's red "can't be saved yet" pop-up takes the clinician to
 * the part of the note it's about when they click OK. This reads which part from the message (the
 * server's sign-off checks and the editor's own); null when it isn't about one part.
 *   'dx'        Diagnosis codes (ICD-10)
 *   'reviewer'  who reviews it (the Signatures card's Send to)
 *   'sec-<key>' a note section (an unedited NotePilot draft names the first one)
 */
export function noteErrTarget(
  msg: string,
  sections: readonly (readonly [string, string, ...unknown[]])[],
): string | null {
  if (/diagnosis code|icd-?10/i.test(msg)) return 'dx';
  if (/reviewer|supervisor|co-?sign/i.test(msg)) return 'reviewer';
  // ehr#682: the editor says "generated text in"; the server still says "NotePilot draft in".
  const draft = /(?:NotePilot draft|generated text) in (.+?) before/i.exec(msg);
  if (draft) {
    const first = draft[1]!.split(',')[0]!.trim().toLowerCase();
    const sec = sections.find(([label]) => label.toLowerCase() === first);
    return sec ? `sec-${sec[1]}` : null;
  }
  return null;
}
